import { useEffect, useState } from 'react';
import { useGetEmployeePurchaseOfficersQuery } from '@Store/api/userApiSlice';

import { Option } from '@Components/types/options';
import { Flex, Typography } from 'antd';
import { MSelect } from '@Components/Base';

import styles from './fields-styles.module.css';

interface PurchaseOfficerFieldsProps {
  setValues: React.Dispatch<
    React.SetStateAction<{
      purchaseOfficer: string;
    }>
  >;
}

const PurchaseOfficerFields: React.FC<PurchaseOfficerFieldsProps> = ({
  setValues,
}) => {
  const { data } = useGetEmployeePurchaseOfficersQuery();
  const [purchaseOfficerOptions, setPurchaseOfficerOptions] = useState<
    Array<Option>
  >([]);

  useEffect(() => {
    if (data) {
      const transformedOfficers = data.map((officer) => ({
        label: `${officer.empName} | ${officer.empNumber}`,
        value: String(officer.userId),
      }));

      setPurchaseOfficerOptions(transformedOfficers);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      <Flex vertical gap={16}>
        <div>
          <Typography.Text>
            Please choose the respective Purchase Officer:
          </Typography.Text>
          <MSelect
            className={styles.purchaseOfficerSelect}
            options={purchaseOfficerOptions}
            onChange={(value) => {
              setValues((prev) => {
                return { ...prev, purchaseOfficer: value };
              });
            }}
            placeholder="Choose Purchase Officer"
          />
        </div>
      </Flex>
    </div>
  );
};

export default PurchaseOfficerFields;
